<template>
    <budget-line @change-action="change" :changing="changing">
        <template v-slot>
            CANTIDAD Y FORMATO <br>
            <div v-for="tray in trays" style="font-weight: normal" :key="tray.id">
                Bandeja {{ tray.unidades }} alvéolos x{{ tray.value }}
            </div>
            <div>
                Plantas total: {{ numPlantsAux }}
            </div>
        </template>
        <template v-slot:icon>
            <img src="/img/iconos/icon_bandeja_custom.svg" alt="Bandeja">
        </template>
        <template v-slot:extra>
            <quantity-select-edit v-show="changing" :seeds-by-alveolus.sync="seedsByAlveolusAux" :seed-price="seedPrice"
                                  :max-seeds-by-alveolus="maxSeedsByAlveolus"
                                  :bp-recommended-tray-format-id="bpRecommendedTrayFormatId"
                                  :bp-recommended-seeds-by-alveolus="bpRecommendedSeedsByAlveolus"
                                  :has-price="hasPrice" :seed-lost-percent="seedLostPercent"
                                  :tray-price-base="trayPriceBase"
                                  :min-order="minOrder" :tray-formats-data="trayFormatsData"
                                  :injerto="injerto"
                                  @changed-num-plants="numPlantsChanged" totals-all-screen
                                  @total-price-changed="totalPriceChanged"
                                  @click-back-varieties-min-order="clickBackVarietiesMinOrder"
                                  @choose-other-variety="$emit('choose-other-variety')"
            ></quantity-select-edit>
        </template>
        <template v-slot:info>
            <img v-b-modal.modal-cantidadformato src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
            <modal-block v-cloak title="Cantidad y formato" desing="ecologico" refer="cantidadformato">
                La cantidad de alvéolos por bandeja, el tamaño varía dependiendo del número alvéolos.<br>
                Número total de plantas que recibirás independientemente del formato de bandeja que escojas
            </modal-block>
        </template>
    </budget-line>
</template>

<script>
    import BudgetLine from "./BudgetLine";
    import AlveolusQuantity from "./AlveolusQuantity";
    import AlveolusQuantityMinOrder from "./AlveolusQuantityMinOrder";
    import SeedsByAlveolus from "./SeedsByAlveolus";
    import SummaryQuantity from "./SummaryQuantity";
    import QuantitySelectTotals from "./QuantitySelectTotals";
    import QuantitySelectEdit from "./QuantitySelectEdit";
    export default {
        name: "BudgetLineQuantity",
        components: {
            QuantitySelectEdit,
            QuantitySelectTotals,
            SummaryQuantity, SeedsByAlveolus, AlveolusQuantityMinOrder, AlveolusQuantity, BudgetLine},
        props: {
            minOrder: {
                type: Number,
                default: 1
            },
            trayFormatsData: {
                type: Array
            },
            seedLostPercent: {
                type: Number
            },
            seedPrice: {
                type: Number
            },
            trayPriceBase: {
                type: Number
            },
            hasPrice: {
                type: Boolean
            },
            bpRecommendedSeedsByAlveolus: {
                type: Number,
                default: 1
            },
            bpRecommendedTrayFormatId: {
                type: Number|String
            },
            maxSeedsByAlveolus: {
                type: Number,
                default: 30
            },
            seedsByAlveolus: {
                type: Number,
                default: 1
            },
            numPlants: {
                type: Number,
                default: 0
            },
            injerto: {
                type: Boolean,
                default: false
            },
            changingLine: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                changing: false,
                seedsByAlveolusAux: 1,
                numPlantsAux: 0
            }
        },
        computed: {
            trays() {
                return this.trayFormatsData.filter(tf => tf.value > 0);
            }
        },
        watch: {
            seedsByAlveolus(value) {
                this.seedsByAlveolusChanged(value);
            },
            seedsByAlveolusAux(value) {
                this.$emit('update:seedsByAlveolus', value);
            },
            numPlantsAux(value) {
                this.$emit('changed-num-plants', value);
            },
            numPlants(value) {
                this.numPlantsChanged(value);
            },
            changingLine(val) {
                this.changing = val;
            },
            changing(val) {
                this.$emit('update:changingLine', val);
            }
        },
        methods: {
            change() {
                this.changing = !this.changing;
            },
            seedsByAlveolusChanged(value) {
                this.seedsByAlveolusAux = value;
            },
            totalPriceChanged(value) {
                this.$emit('total-price-changed', value);
            },
            numPlantsChanged(value) {
                this.numPlantsAux = value;
            },
            clickBackVarietiesMinOrder() {
                this.$emit('click-back-varieties-min-order');
            }
        },
        created() {
            this.numPlantsChanged(this.numPlants);
            this.seedsByAlveolusChanged(this.seedsByAlveolus);
            this.changing = this.changingLine;
        }
    }
</script>

<style scoped>

</style>
